import { formatNumberWithSuffix } from "~/utils/formatting"

export const RowDelta: React.FC<{ delta: number | null }> = ({ delta }) => {
  if (delta == null) return <span className="text-secondary">—</span>
  if (delta === 0) return <span className="text-secondary">0</span>
  return (
    <span className={delta > 0 ? "text-green-500" : "text-red-500"}>
      {delta > 0 ? "+" : ""}
      {formatNumberWithSuffix(delta, 2)}
    </span>
  )
}
